import React from 'react';

const CustomerDetails = ({ details }) => (
    <div className="p-4 max-w-[700px]">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-2">
      <p><strong>Name:</strong> {details.name}</p>
      <p><strong>Phone:</strong> {details.phone}</p>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <p><strong>Email:</strong> {details.email}</p>
      <p><strong>Address:</strong> {details.address}</p>
    </div>
  </div>
);

export default CustomerDetails;
